import { useEffect } from 'react';
import { useColorMode } from '@telescope/cassini-ui';
import { useWidget } from '@telescope/cassini-hooks';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AppShell } from 'components';
import { SnapshotType } from 'types';
import { BingoApp, ClosedPage } from 'features';
import { AuthRoutes, useAuth } from 'features';
import { ROUTES } from 'utils';


const ProtectedRoute = ({ children } : { children: any }) => {
  const { user } = useAuth();
  if (!user) {
    // user is not authenticated
    return <Navigate to={ROUTES.LOGIN} />;
  }
  return children;
};

// Returns the root level view based on the currently live snapshot type
const CurrentSnapshot = (props: { type: SnapshotType }) => {
  switch (props.type) {
    case SnapshotType.OPEN:
      return <ProtectedRoute> <BingoApp /> </ProtectedRoute>
    case SnapshotType.CLOSED:
      return <ClosedPage />
    default:
      return null;
  }
};

export const AppRoutes = () => {
  const { data: colorModeSettings } = useWidget({ select: (data: any) => data.widget.theme.settings.colorMode  });
  const { data } = useWidget({ select: (data: any) => data.snapshot });
  const { colorMode, toggleColorMode } = useColorMode()
  const location = useLocation();

  useEffect(() => {
    window.scrollTo( 0, 0 );
  }, [location]);
  
  // Update colorMode when app settings changes
  useEffect(() => {
    if (colorModeSettings !== colorMode) {
      toggleColorMode()
    }
  }, [colorModeSettings]);

  return (
    <>
      <Routes>
        <Route path="/" element={<AppShell />}>
          <Route index={true} element={
            <CurrentSnapshot type={data.type as SnapshotType} />
          }/>
          <Route path="auth/*" element={<AuthRoutes isEnabled={data.type === SnapshotType.OPEN} />}/>
          <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Route>
      </Routes>
    </>
  )
}